import glamorous from "glamorous";
import styles from '../../../styles';

const ContentContainer = glamorous.div(styles.background.contentContainer);

const PageContainer = glamorous.div(styles.background.pageContainer);

export { ContentContainer, PageContainer };


// WEBPACK FOOTER //
// ./src/components/areas/Background/Styles.js